import { Box } from './Box';
import { Multi } from './Multi';
import { Single } from './Single';
import { Text } from './Text';

export const Animated = {
  Box,
  Multi,
  Single,
  Text,
};
